module.exports = __webpack_public_path__ + "media/images/banner-about-26994cb4c285e516fc9f5b9beae7a204.png";